import { FC } from "react";
import LocationSearchInput from "components/GoogleMaps/LocationSearchInput";
import GuestsInput from "../GuestsInput";
import StayDatesRangeInput from "./StayDatesRangeInput";
import TypeSelector from "../TypeSelector";
import MoodSelector from "../MoodSelector";

interface StaySearchFormProps {
  handleSearch: () => void;
  searchType: number;
  moodType?: number;
}

const StaySearchForm: FC<StaySearchFormProps> = ({ handleSearch, searchType, moodType }) => {

  const renderForm = () => {
    return (
      <form
        onSubmit={handleSearch}
        className="w-full relative mt-8 flex rounded-full shadow-xl dark:shadow-2xl bg-white dark:bg-neutral-800">
        <LocationSearchInput className="flex-[1.1]" />
        <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
        <StayDatesRangeInput className="flex-1" />
        <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
        <TypeSelector
          onSelectType={() => null}
          className="flex-[0.5]"
          defaultType={searchType}
        />
        <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
        <MoodSelector
          onSelectType={() => null}
          className="flex-[0.7]"
          defaultType={moodType}
        />
        <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
        <GuestsInput
          handleSubmit={handleSearch}
          className="flex-1"
        />
      </form>
    );
  };

  return renderForm();
};

export default StaySearchForm;
